import React from 'react';

const FormRow = () => {
	return (
		<div>

		</div>
	);
};

export default FormRow;